import React from "react";
import "./Home.css";
import Banner from "../../Components/Home/Banner/Banner";
import BestSellingItem from "../../Components/Home/BestSellingItem/BestSellingItem";
import Faq from "../../Components/Home/Faq/Faq";
import Collection from "../../Components/Home/Collection/Collection";
import CustomerGallery from "../../Components/Home/CustomerGallery/CustomerGallery";
import FinalSlider from "../../Components/Home/FinalSlider/FinalSlider";
import ActiveBanner from "../../Components/Home/ActiveBanner/ActiveBanner";
import SEO from "../../common/SEO/SEO";

const homeSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://mayawears.com.np/#organization",
      "name": "Maya Wears",
      "url": "https://mayawears.com.np",
      "logo": {
        "@type": "ImageObject",
        "url": "https://mayawears.com.np/logo-1.webp",
        "caption": "Maya Wears Brand Logo"
      },
      "sameAs": [
        "https://www.instagram.com/mayawears.np/"
      ],
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+977-9849531357",
        "contactType": "customer service",
        "areaServed": "NP",
        "availableLanguage": ["en", "ne"]
      }
    },
    {
      "@type": "WebSite",
      "@id": "https://mayawears.com.np/#website",
      "url": "https://mayawears.com.np",
      "name": "Maya Wears",
      "description": "Crafting Creativity - Contemporary Fashion Nepal",
      "publisher": { "@id": "https://mayawears.com.np/#organization" },
      "potentialAction": {
        "@type": "SearchAction",
        "target": "https://mayawears.com.np/all_product",
        "query-input": "required name=search"
      }
    }
  ]
};

const Home = () => {
  return (
    <div>
      <SEO
        title="Maya Wears | Crafting Creativity"
        description="Discover contemporary streetwear, oversized tees, jackets, and timeless silhouettes at Maya Wears. Designed with restraint, made to remain. Shop online Nepal."
        keywords="Maya Wears, Crafting Creativity, streetwear Nepal, oversized t-shirt Nepal, fashion clothing Kathmandu, buy streetwear Nepal, Maya clothing"
        canonical="https://mayawears.com.np/"
        schema={homeSchema}
      />
      <Banner />   
      <FinalSlider/>        
      {/* <ActiveBanner/> */}
      <Collection limit={4} />
      <BestSellingItem />
      <CustomerGallery />
      {/* <Faq /> */}
    </div>
  );
};

export default Home;
